import React from 'react'
import { Breadcrumbs as MuiBreadcrumbs, Typography } from '@material-ui/core'

const Breadcrumbs = ({ pathObjects, ...props }) => (
  <MuiBreadcrumbs {...props}>
    {pathObjects.map(({ title, href, linkProps }, index) => {
      const isLastPathObject = index === pathObjects.length - 1
      const hasMultiplePathObjects = pathObjects.length > 1

      if (hasMultiplePathObjects && isLastPathObject) {
        return <Typography key={index}>{title}</Typography>
      }

      return (
        <Typography
          key={index}
          href={href}
          underline
          {...linkProps}
          component="a"
        >
          {title}
        </Typography>
      )
    })}
  </MuiBreadcrumbs>
)

export default Breadcrumbs
